<div class="dialog-container">
  @if (!selectedContact()) {
    <h2 mat-dialog-title>{{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.TITLE' | translate }}</h2>

    @if (data.hasUnsavedChanges) {
      <div class="unsaved-warning">
        {{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.UNSAVED_CHANGES_WARNING' | translate }}
      </div>
    }

    <div class="search-container">
      <glxy-form-field suffixIcon="search">
        <input
          matInput
          type="text"
          placeholder="{{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.SEARCH_PLACEHOLDER' | translate }}"
          [formControl]="contactSearchFormField"
        />
      </glxy-form-field>
    </div>

    <mat-dialog-content class="contacts-list">
      @for (contact of contacts(); track contact.id) {
        <div class="contact-item" (click)="selectContact(contact)">
          <div class="contact-name">{{ contact.name }}</div>
          <div class="contact-email">{{ contact.email }}</div>
        </div>
      }
      @if (hasMore()) {
        <glxy-infinite-scroll-trigger (isVisible)="loadMoreContacts()"></glxy-infinite-scroll-trigger>
      }
      @if (loading()) {
        <div class="loading-shimmer stencil-shimmer"></div>
      } @else if (contacts().length === 0) {
        <div class="empty-state">
          {{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.NO_CONTACTS' | translate }}
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-stroked-button (click)="cancel()">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  } @else {
    <h2 mat-dialog-title>{{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.CONFIRM_TITLE' | translate }}</h2>

    <mat-dialog-content class="confirmation-content">
      @if (data.hasUnsavedChanges) {
        <div class="unsaved-warning">
          {{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.UNSAVED_CHANGES_WARNING' | translate }}
        </div>
      }
      <p class="confirmation-message">
        {{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.CONFIRM_MESSAGE' | translate }}
      </p>
      <div class="selected-contact">
        <div class="contact-name">{{ selectedContact()?.name }}</div>
        <div class="contact-email">{{ selectedContact()?.email }}</div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-stroked-button (click)="backToList()" [disabled]="sending()">
        {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="confirmSend()" [disabled]="sending()">
        @if (sending()) {
          <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
        } @else {
          {{ 'CONTENT_BUILDER.SEND_PREVIEW_DIALOG.SEND_BUTTON' | translate }}
        }
      </button>
    </mat-dialog-actions>
  }
</div>
